import React, { createContext, useState } from 'react'

type FileContextType = {
  selectedFile: File | null
  setSelectedFile: (file: File | null) => void
  children: React.ReactNode
}

export const FileContext = createContext<FileContextType>({
  selectedFile: null,
  setSelectedFile: () => void 0,
  children: null
})

export const FileProvider = ({ children }: FileContextType) => {
  const [ selectedFile, setSelectedFile ] = useState<File | null>(null)

  return (
    <FileContext.Provider value={{ selectedFile, setSelectedFile, children }}>
      {children}
    </FileContext.Provider>
  )
}